import { render, staticRenderFns } from "./sponsorbanner.vue?vue&type=template&id=26cf19fe&"
import script from "./sponsorbanner.vue?vue&type=script&lang=js&"
export * from "./sponsorbanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports